import { take } from "rxjs/operators";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from "@ngx-translate/core";
import type { MultiSelectChangeEvent } from "primeng/multiselect";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-slide-edit-poi-image-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './poi-image-form.component.html',
    styleUrls: ['./poi-image-form.component.scss'],
    standalone: false
})
export class PoiImageFormComponent {
  #poi: FlatModels.PointOfInterestEntityModels.PointOfInterest | null;
  #imageIds: string[];
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public translate: TranslateService) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlidePoi$.pipe(takeUntilDestroyed()).subscribe((poi) => {
      this.#poi = poi;
      this.#updateImageIds();
    });
  }
  
  #updateImageIds() {
    if (this.#poi) {
      this.slideAuthorFacade.imageIdsByPoi$(this.#poi.id).pipe(take(1)).subscribe((imageIds) => {
        this.#imageIds = imageIds;
      });
    } else {
      this.#imageIds = [];
    }
  }
  
  onChange(event: MultiSelectChangeEvent) {
    if (!this.#poi) return;
    const imagesToAdd = event.value.filter((v: string) => !this.#imageIds.includes(v));
    const imagesToRemove = this.#imageIds.filter(v => !event.value.includes(v));
    
    if (imagesToAdd.length > 0) {
      this.slideAuthorFacade.requestAddPoiIdToImages(imagesToAdd, this.#poi.id, 'history.poi_add_to_images').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updateImageIds()
      });
    } else if (imagesToRemove.length > 0) {
      if (this.#imageIds.length === imagesToRemove.length) {
        imagesToRemove.shift();
      }
      this.slideAuthorFacade.requestRemovePoiFromImages(imagesToRemove, this.#poi.id, 'history.poi_remove_from_images').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updateImageIds()
      });
    }
  }
}
